import { render, staticRenderFns } from "./SolutionModule.vue?vue&type=template&id=56ea87bc&scoped=true"
import script from "./SolutionModule.vue?vue&type=script&lang=js"
export * from "./SolutionModule.vue?vue&type=script&lang=js"
import style0 from "./SolutionModule.vue?vue&type=style&index=0&id=56ea87bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ea87bc",
  null
  
)

export default component.exports